import {
  Avatar,
  Box,
  Divider,
  IconButton,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../redux/hooks';
import {
  ArrowLeftIcon,
  // BellIcon,
  UserIcon,
  SettingsIcon,
  LogoutIcon,
  ReceiptCheckIcon,
} from '../../components/shared/CustomIcons';
import { useDispatch } from 'react-redux';
import { clearAuthData } from '../../redux/slices/authSlice';
import queryClient from '../../lib/queryClient';

import { PROFILE_ROUTES, ROUTES } from '../../constants/paths';

const ProfileUI = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    email,
    fullName,
    profile_url = '',
  } = useAppSelector((state) => state.auth.currentUser) || {};

  const handleLogout = () => {
    dispatch(clearAuthData());
    queryClient.resetQueries();
    // queryClient.clear()
    localStorage.clear();
    navigate('/');
  };

  return (
    <Box sx={{ bgcolor: 'grey.50', px: 2, py: 8 }} className="flex-1">
      <Box sx={{ px: 1 }}>
        <IconButton
          aria-label="back"
          sx={{ p: 0, mb: 4 }}
          onClick={() => navigate('/dashboard')}
        >
          <ArrowLeftIcon sx={{ fontSize: 40, color: 'text.primary' }} />
        </IconButton>
        <Box sx={{ gap: 3 }} className="d-flex align-items-center">
          <Avatar
            src={profile_url || ''}
            sx={{
              width: 80,
              height: 80,
              border: '4px solid',
              borderColor: 'primary.main',
            }}
            alt="User"
          />
          <Box className="flex-1">
            <Typography variant="h6" sx={{ color: 'primary.main', mb: 1 }}>
              {fullName}
            </Typography>
            <Typography
              variant="caption"
              component="p"
              sx={{ color: 'text.secondary', wordBreak: 'break-all' }}
            >
              {email}
            </Typography>
          </Box>
        </Box>
        <ListItemButton
          sx={{
            color: 'white',
            gap: 2,
            px: 1,
            py: 2,
            mt: 3,
            borderRadius: 4,
            boxShadow: '10px 10px 20px rgba(0, 0, 0, 0.1)',
            '&:hover': {
              '& .icon, & .text': {
                color: '#4A168C',
              },
            },
          }}
          onClick={() =>
            navigate(ROUTES.PROFILE + PROFILE_ROUTES.PAYMENT_HISTORY)
          }
        >
          <Box
            sx={{
              backgroundColor: '#F6F6FF',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 48,
              height: 48,
            }}
          >
            <ReceiptCheckIcon
              className="icon"
              sx={{
                color: '#7625DC',
                width: 24,
                height: 24,
              }}
            />
          </Box>
          <ListItemText
            primary="Your payment history"
            className="text"
            sx={{
              m: 0,
              color: '#7625DC',
              fontWeight: 'bold',
            }}
            disableTypography
          />
        </ListItemButton>
      </Box>
      <Divider sx={{ borderColor: 'solitude.main', mx: 1, my: 2 }} />

      <List component="div" sx={{ p: 0 }}>
        <ListItemButton
          sx={{ color: 'grey.900', gap: 2, px: 1, py: 2, borderRadius: 4 }}
          onClick={() => navigate('/profile/details')}
        >
          <ListItemIcon sx={{ minWidth: 24 }}>
            <UserIcon sx={{ color: 'grey.900', width: 24, height: 24 }} />
          </ListItemIcon>
          <ListItemText primary="Profile" sx={{ m: 0 }} disableTypography />
        </ListItemButton>
        <ListItemButton
          sx={{ color: 'grey.900', gap: 2, px: 1, py: 2, borderRadius: 4 }}
          onClick={() => navigate('/profile/settings')}
        >
          <ListItemIcon sx={{ minWidth: 24 }}>
            <SettingsIcon sx={{ color: 'grey.900', width: 24, height: 24 }} />
          </ListItemIcon>
          <ListItemText primary="Settings" sx={{ m: 0 }} disableTypography />
        </ListItemButton>
        <Divider sx={{ borderColor: 'solitude.main', mx: 1, my: 2 }} />
        <ListItemButton
          sx={{
            color: 'secondary.main',
            gap: 2,
            px: 1,
            py: 2,
            borderRadius: 4,
          }}
          onClick={handleLogout}
        >
          <ListItemIcon sx={{ minWidth: 24 }}>
            <LogoutIcon
              sx={{ width: 24, height: 24, color: 'secondary.main' }}
            />
          </ListItemIcon>
          <ListItemText primary="Log out" sx={{ m: 0 }} disableTypography />
        </ListItemButton>
      </List>
    </Box>
  );
};

export default ProfileUI;
